import AccountTreeIcon from "@mui/icons-material/AccountTree";

import TreeList from "./List";

export const getUrlTreesResource = ({ permission, treeName, treeType, label = "Навигация" }) => {
  return {
    isMenu: true,
    icon: <AccountTreeIcon />,
    name: `url-trees-cms/${treeName}`,
    title: label,
    list: <TreeList name={treeType} />,
    permission,
  };
};
